import UnauthorizedContent from './UnauthorizedContent';

export default UnauthorizedContent;
